import { render, staticRenderFns } from "./InputArea.vue?vue&type=template&id=bac584a8&scoped=true&"
import script from "./InputArea.vue?vue&type=script&lang=js&"
export * from "./InputArea.vue?vue&type=script&lang=js&"
import style0 from "./InputArea.vue?vue&type=style&index=0&id=bac584a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac584a8",
  null
  
)

export default component.exports